import $ from 'jquery';
import navigator from '../internal/navigator';
import localize from '../localize';
import flatten from 'lodash/flatten';
const Resx = localize('DataTables');

function buttonTemplate(text, page, enabled, active) {
    const link = page && enabled ? `?page=${page}` : 'javascript:void(0)';
    const classes = ['page-item'];
    if(active) classes.push('active');
    else if(!enabled) classes.push('disabled');
    return `<li class="${classes.join(' ')}"><a href="${link}">${text}</a></li>`;
}

$(document).on('click', '[data-pagination] a', function () {
    const $this = $(this);
    const $dataContainer = $($this.closest('[data-pagination]').attr("data-pagination"));
    if (!$this.is('.disabled')) {
        setTimeout(function () {
            $.scrollTo($dataContainer, {duration: 300, offset: { top: -80}});
        }, 100);
    }
});

function initPagination() {
    const $this = $(this);
    $this.attr('data-query', true);
    const $dataContainer = $($this.attr("data-pagination"));
    const lengthMenu = ($this.attr("data-length-menu") || '10,20,50,100').split(',').map(i => parseInt(i, 10));
    let paging = null;
    try {
        paging = JSON.parse($dataContainer.find('[data-paging="true"]').val());
    } catch (e) {
    }
    if(!paging) paging = { totalCount: 0, pageSize: 20};

    if(!paging.totalCount) return;

    const page = paging.page || 1;
    const pages = Math.ceil(paging.totalCount/paging.pageSize);
    const items = $.fn.DataTable.ext.pager.simple_numbers(page - 1, pages);
    const itemsHtml = flatten(items).map(i => {
        switch(i){
            case 'previous':
                return buttonTemplate(Resx.DataTables.oPaginate_sPrevious, page - 1, page > 1);
            case 'next':
                return buttonTemplate(Resx.DataTables.oPaginate_sNext, page + 1, page < pages);
            case 'ellipsis':
                return buttonTemplate('&#x2026;');
            default:
                if(typeof i === 'number' && !isNaN(i)) {
                    let p = i + 1;
                    return buttonTemplate(p, p, p !== page, p === page);
                }
                break;
        }
        return '';
    }).join('');

    const info = Resx.DataTables.sInfo
        .replace('_START_', ((page - 1) * paging.pageSize) + 1)
        .replace('_END_', Math.min(page * paging.pageSize, paging.totalCount))
        .replace('_TOTAL_', paging.totalCount);

    const pageLengthSelect = `<select class="form-control input-sm length-menu" tabindex="-1">
                ${lengthMenu.map(i => `<option value="${i}" ${i === paging.pageSize ? 'selected':''}>${i}</option>`)}
            </select>`;

    $this.html(`<div class="dataTables_wrapper ">
        <div class="dataTables_length"><label>${Resx.DataTables.sLengthMenu.replace('_MENU_', pageLengthSelect)}</label></div>
        <div class="dataTables_info" role="status" aria-live="polite">${info}</div>
        <div class="dataTables_paginate paging_simple_numbers"><ul class="pagination">${itemsHtml}</ul></div>
    </div>`);
}

$(document).on('change', 'select.length-menu', function(){
    const $this = $(this);
    navigator.navigate({ pageSize: $this.val() }, $this.closest('[data-pagination]'));
});


export default function () {
    $(this).find("[data-pagination]").each(initPagination);
}


// WEBPACK FOOTER //
// ./node_modules/linksoft/src/initializers/pagination.js